import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import ContractorWebsites from "@/pages/ContractorWebsites";

export const Route = createFileRoute("/contractor-websites/")({
  component: ContractorWebsites,
  head: () =>
    pageHead({
      title: "Contractor Web Design | Seattle & King County, WA | jaik",
      description: "Contractor web design for Seattle and King County trades. Roofing, plumbing, HVAC and remodeling sites built to rank locally and bring in calls. Starter SEO included.",
      path: "/contractor-websites",
    }),
});
